export enum HearkenStatus {
  COLLECTING = 'collecting',
  VOTING = 'voting',
  INVESTIGATING = 'investigating',
  PUBLISHING = 'publishing'
}
